import { apiFetch, MOBILE_API } from "./api";

export interface BuyerProfileUpdate {
  email?: string | null;
  gender?: "male" | "female" | "prefer_not_to_say" | "";
  name?: string;
}

/**
 * Update the logged-in buyer's own profile.
 * `city` is not stored on the user — it comes from the default address.
 */
export async function updateBuyerProfile(token: string, payload: BuyerProfileUpdate) {
  return apiFetch<{ success: boolean; data?: unknown; error?: string }>(
    `${MOBILE_API}/users/me/edit`,
    { method: "PUT", body: payload, token }
  );
}
